<template>
  <v-dialog v-model="confirmXferDlg" persistent max-width="400px">
    <v-card>
      <v-card-title class="title" primary-title>
        <v-icon class="mr-3" color="primary">mdi-phone-forward</v-icon>
        {{$t('sipua.xfer.title2')}}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-4">
        <span >{{$t('sipua.xfer.title')}} {{ buddy.name }} &lt;{{buddy.exten}}&gt;?</span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="xferDo(false)" text>{{$t('sipua.xfer.cancel')}}</v-btn>
        <v-btn @click="xferDo(true)" text color="primary">{{$t('sipua.xfer.confirm')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'buddy-view-switch',
  props: {
    buddy: {
      type: Object,
      required: true
    },
    confirmXferDlg: {
      type: Boolean,
      default: false
    },
    xferCallId: {
      type: String,
      default: '',
      required: true
    },
    xferNumber: {
      type: String,
      default: '',
      required: true
    }
  },
  methods: {
    ...mapActions({
      xferCall: 'sipua/xferCall'
    }),
    xferDo: function (confirmed) {
      if (confirmed) {
        this.xferCall({ callid: this.xferCallId, number: this.buddy.exten })
      }
      this.$emit('close-xfer-dialog')
    }
  }
}
</script>

<style>

</style>
